module.exports = __webpack_public_path__ + "img/icon-self-tab.59119b03.png";